import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

const TimesIcon = (props) => <FontAwesomeIcon icon={["fas", "times"]} {...props}/>

export default TimesIcon;